import { useContext } from 'react';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { uniq } from 'lodash';

export const ContentSidebarJobPreferencesDesiredJobs = () => {
  const { userProfile, hasPreferences } = useContext(ContactSidebarContext);

  if (!hasPreferences.desiredJobs) {
    return null;
  }

  const userProfileId = userProfile?.id;
  const desiredJobs = userProfile?.desiredJobs();

  return (
    <div className="space-y-1.5">
      <p className="text-primary-pure-blue">Positions:</p>
      <ul className="space-y-0.5 list-disc pl-4">
        {uniq(desiredJobs).map((job) => (
          <li key={`${userProfileId}-${job}`}>{job}</li>
        ))}
      </ul>
    </div>
  );
};

ContentSidebarJobPreferencesDesiredJobs.displayName = 'ContentSidebarJobPreferencesDesiredJobs';
